import React from 'react';
import { Form, InputNumber } from 'antd';

// https://ant.design/components/form/#components-form-demo-basic
const FormNumberField = ({ label, name, rules, ...rest }) => {
  return (
    <Form.Item label={label} name={name} rules={rules}>
      <InputNumber {...rest} />
    </Form.Item>
  );
};

export default FormNumberField;
